(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ajax-cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.currentScript.closest('.p11-cart-drawer');
    if (!root) return;

    const panel = root.querySelector('.p11-cart-drawer__panel');
    const closeButtons = Array.from(root.querySelectorAll('[data-cart-drawer-close]'));
    const itemsNode = root.querySelector('[data-cart-items]');
    const emptyNode = root.querySelector('[data-cart-empty]');
    const subtotalNode = root.querySelector('[data-cart-subtotal]');
    const progressCopyNode = root.querySelector('[data-cart-progress-copy]');
    const progressMeterNode = root.querySelector('[data-cart-progress-meter]');
    const cartJsonUrl = root.dataset.cartJsonUrl;
    const cartChangeUrl = root.dataset.cartChangeUrl;
    const currencyCode = root.dataset.currency || 'GBP';
    const threshold = Number(root.dataset.freeShippingThreshold || 7500);

    const formatMoney = (value) => {
      if (typeof value !== 'number') return '';
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currencyCode
      }).format(value / 100);
    };

    const escapeHtml = (value) => {
      const div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    };

    const openDrawer = () => {
      root.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    const renderProgress = (cart) => {
      if (!progressCopyNode || !progressMeterNode) return;
      const gap = Math.max(threshold - cart.total_price, 0);
      const progress = Math.min((cart.total_price / threshold) * 100, 100);
      progressMeterNode.style.width = progress + '%';
      progressCopyNode.textContent = gap === 0
        ? 'Free tracked UK delivery unlocked.'
        : 'Add ' + formatMoney(gap) + ' more to unlock Free Tracked UK Delivery.';
    };

    const renderItems = (cart) => {
      if (!itemsNode || !emptyNode || !subtotalNode) return;

      subtotalNode.textContent = formatMoney(cart.total_price);

      if (!cart.items || !cart.items.length) {
        itemsNode.innerHTML = '';
        itemsNode.classList.add('is-hidden');
        emptyNode.classList.remove('is-hidden');
        renderProgress(cart);
        document.dispatchEvent(new CustomEvent('p11:cart-refresh'));
        return;
      }

      emptyNode.classList.add('is-hidden');
      itemsNode.classList.remove('is-hidden');

      itemsNode.innerHTML = cart.items.map((item, index) => {
        const image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image || '';
        const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="p11-cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';
        const imageMarkup = image
          ? '<img class="p11-cart-drawer__image" src="' + escapeHtml(image) + '" alt="" loading="lazy" width="220" height="275">'
          : '';

        return '<li class="p11-cart-drawer__item" data-cart-line="' + (index + 1) + '"><a class="p11-cart-drawer__item-media" href="' + escapeHtml(item.url) + '">' + imageMarkup + '</a><div class="p11-cart-drawer__item-copy"><a class="p11-cart-drawer__item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variantTitle + '<div class="p11-cart-drawer__item-footer"><div class="p11-cart-drawer__qty"><button type="button" aria-label="Decrease quantity" data-cart-qty-button data-cart-qty-action="decrease" data-line="' + (index + 1) + '">-</button><span data-cart-line-quantity>' + item.quantity + '</span><button type="button" aria-label="Increase quantity" data-cart-qty-button data-cart-qty-action="increase" data-line="' + (index + 1) + '">+</button></div><div class="p11-cart-drawer__line-price">' + escapeHtml(formatMoney(item.final_line_price)) + '</div></div></div></li>';
      }).join('');

      renderProgress(cart);
      document.dispatchEvent(new CustomEvent('p11:cart-refresh'));
    };

    const fetchCart = (openAfter) => {
      if (!cartJsonUrl) return;
      fetch(cartJsonUrl, {
        headers: {
          Accept: 'application/json'
        }
      })
        .then((response) => response.ok ? response.json() : null)
        .then((cart) => {
          if (!cart) return;
          renderItems(cart);
          if (openAfter) openDrawer();
        })
        .catch(() => {});
    };

    const updateQuantity = (line, quantity) => {
      if (!cartChangeUrl) return;
      fetch(cartChangeUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
        .then((response) => response.ok ? response.json() : null)
        .then((cart) => {
          if (!cart) return;
          renderItems(cart);
        })
        .catch(() => {});
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target instanceof Element ? event.target.closest('[data-p11-cart-toggle]') : null;
      if (toggle) {
        event.preventDefault();
        fetchCart(true);
        return;
      }

      const qtyButton = event.target instanceof Element ? event.target.closest('[data-cart-qty-button]') : null;
      if (qtyButton) {
        const itemNode = qtyButton.closest('[data-cart-line]');
        const quantityNode = itemNode ? itemNode.querySelector('[data-cart-line-quantity]') : null;
        const currentQuantity = quantityNode ? Number(quantityNode.textContent || '0') : 0;
        const action = qtyButton.getAttribute('data-cart-qty-action');
        const line = Number(qtyButton.getAttribute('data-line') || '0');
        const nextQuantity = action === 'decrease' ? currentQuantity - 1 : currentQuantity + 1;
        if (line > 0 && nextQuantity >= 0) {
          updateQuantity(line, nextQuantity);
        }
      }
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    document.addEventListener('p11:cart-open', () => {
      fetchCart(true);
    });

    document.addEventListener('p11:cart-refresh', () => {
      if (root.classList.contains('is-open')) {
        fetchCart(false);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
